<template>
  <div class="projectCard card">
    <img :src="data.imageLink" alt="image" />
    <div>
      <p class="date">{{ data.date }}</p>
      <h1>
        {{ data.name }}
      </h1>
      <div class="tags">
        <p class="pink-tag" v-for="item in data.tags" v-bind:key="item">
          {{ item }}
        </p>
      </div>
      <p class="description">{{ data.description }}</p>

      <div class="btn-container">
        <a
          v-for="item in data.buttons"
          v-bind:key="item.label"
          :href="item.link"
          class="see-more-btn"
          target="_blank"
          >{{ item.label }} <i class="fas fa-chevron-right"></i
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: null
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/_media_sizes.scss";
@import "@/assets/_colours.scss";
@import "@/assets/_font.scss";

.projectCard {
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  img {
    width: 100%;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  & > div {
    flex-grow: 1;
    position: relative;
    border-top: 1px solid $blue-grey;
    padding: 10px 25px 35px 25px;
    display: flex;
    flex-direction: column;

    .date {
      color: $accent-blue;
      font-family: "PT Mono", monospace;
      font-size: $font-XS;
      margin-bottom: 0;
    }

    h1 {
      font-family: "Roboto", sans-serif;
      font-size: $font-M;
      font-weight: 600;
      margin-top: 5px;
      margin-bottom: 0;
    }

    p {
      font-size: $font-XS;
      color: $text-grey;
    }

    .tags {
      margin: 5px 0 10px 0;
    }

    .description {
      margin-top: 0;
      margin-bottom: 30px;
    }

    .btn-container {
      text-align: center;
      flex-grow: 1;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      position: relative;

      .see-more-btn {
        font-size: $font-XS !important;
        font-weight: 600;
        text-transform: uppercase;
        background: $accent-lightest-blue;
        color: $accent-darker-blue;
        padding: 10px 20px;
        border-radius: 2em;
        text-align: center;
        letter-spacing: 1px;
        text-decoration: none !important;
        position: relative;
        z-index: 2;

        &:hover {
          cursor: pointer;
        }

        @media only screen and (min-width: $desktop) {
          background: none;

          &:hover {
            &:after {
              width: 100%;
            }
          }

          &:after {
            content: "";
            position: absolute;
            width: 40px;
            height: 40px;
            background: $accent-lightest-blue;
            top: 0;
            left: 0;
            border-radius: 2em;
            transition-duration: 0.3s;
            z-index: -1;
          }
        }
      }
    }
  }
}
</style>
